/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetTBillTableError = (data) => ({
  type: actionTypes.TBILL_ERROR,
  errorField: data,
});

export const tBillTableError = (value) => (dispatch) => {
  dispatch(dispatchGetTBillTableError(value));
};

export const dispatchGetTBillTableDetails = (data) => ({
  type: actionTypes.GET_TBILLTABLE_DATA,
  rebateTBillSearchResult: data,
});
export const setUpdateTBillData = (value) => (dispatch) => {
  dispatch(dispatchGetTBillTableDetails(value));
};

export const dispatchGetTBillTableEditedData = (data) => ({
  type: actionTypes.GET_TBILLTABLE_EDITED_DATA,
  editedData: data,
});
export const setTBillEditedData = (value) => (dispatch) => {
  dispatch(dispatchGetTBillTableEditedData(value));
};

export const dispatchGetTBillExtraState = (data) => ({
  type: actionTypes.TBILL_EXTRA_STATE,
  extraState: data,
});
export const setTBillExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetTBillExtraState(value));
};

export const setNewTBillRow = (payload) => {
  return {
    type: actionTypes.ADD_NEW_TBILL_DATA,
    payload,
  };
};
export const addNewRowData = (payload, action) => {
  return (dispatch, getState) => {
    const dataList = [...getState().sharedState.TBillTableReducer.allTBillList];
    if (Array.isArray(payload) && payload && payload.length > 0) {
      const newObj = [...payload];

      dispatch(setNewTBillRow(payload));
    } else {
      const temp = [...dataList];
      temp.unshift(payload);
      dispatch(setNewTBillRow(temp));
    }
  };
};
export const getTBillTableDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_TBILLTABLE_DATA, values)
    .then((response) => {
      let newData = response.data && response.data.data;
      if (response.data && response.data.data) {
        newData = newData.map((val, ind) => {
          val.isEdit = false;
          val.isError = false;
          val.id = uuidv4();
          return val;
        });
      }
      dispatch(dispatchGetTBillTableDetails(newData));
      dispatch(setNewTBillRow(newData));
    })
    .catch((error) => {
      dispatch(dispatchGetTBillTableDetails({ error: 'API failed' }));
    });
};

export const updateTBillRatesTableDetail = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_TBILLTABLE_DATA, values)
    .then((response) => {
      if (response.status == '200') {
        dispatch(getTBillTableDetails());
      }
    })
    .catch((error) => {
      dispatch(dispatchGetTBillTableDetails(error.response.data));
    });
};
export const dispatchViewHistoryPlan = (values) => {
  return {
    planViewHistory: values,
    type: actionTypes.VIEW_HISTORY,
  };
};
export const viewHistoryPlans = (values) => (dispatch) => {
  if (values === null) {
    return dispatch(dispatchViewHistoryPlan(null));
  }
  return axios
    .post(`${serviceEndPoint.VIEW_HISTORY}`, values)
    .then((response) => {
      return dispatch(
        dispatchViewHistoryPlan(
          response.data && response.data.responseAuditLogDetails
        )
      );
    })
    .catch(() => {
      return dispatch(dispatchViewHistoryPlan([]));
    });
};

export const dispatchClearTBillReduxStore = (data) => ({
  type: actionTypes.TBILL_CLEAR_REDUX_STORE,
  payload: data,
});
